export default __webpack_public_path__ + "static/media/watson-9.bf5877c2.png";